var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUt2Jensfea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 30,
    viewBox: "0 0 36.56 23.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff9300;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.68,.44V4.64c0,.42,.1,.74,.31,.97s.51,.34,.91,.34,.71-.11,.92-.34,.32-.55,.32-.97V.44h1.71V4.63c0,.63-.13,1.16-.4,1.59-.27,.43-.62,.76-1.07,.98-.45,.22-.95,.33-1.5,.33s-1.05-.11-1.49-.33-.78-.54-1.03-.98c-.25-.44-.38-.97-.38-1.59V.44h1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.1,.44V1.81h-1.86V7.46h-1.71V1.81h-1.86V.44h5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.04,5.84c.65-.54,1.17-.98,1.54-1.33s.7-.71,.96-1.09,.39-.75,.39-1.11c0-.27-.06-.49-.19-.64-.13-.15-.32-.23-.57-.23s-.45,.09-.59,.28c-.14,.19-.21,.46-.21,.81h-1.65c.01-.57,.13-1.04,.37-1.42,.23-.38,.53-.66,.91-.84,.38-.18,.79-.27,1.25-.27,.79,0,1.39,.2,1.79,.61,.4,.41,.61,.94,.61,1.59,0,.71-.24,1.38-.73,1.98-.49,.61-1.11,1.21-1.86,1.79h2.7v1.39h-5.02v-1.27c.23-.18,.33-.26,.31-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.07,.44V5.22c0,.74-.21,1.31-.62,1.71-.42,.4-.98,.6-1.68,.6s-1.33-.21-1.78-.63c-.45-.42-.67-1.02-.67-1.79h1.7c0,.29,.06,.51,.18,.67,.12,.15,.29,.22,.52,.22,.21,0,.37-.07,.48-.2,.11-.13,.17-.33,.17-.58V.44h1.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.71,17.81v1.42h2.29v1.32H1.71v1.54h2.59v1.37H0v-7.02H4.3v1.37H1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.69,23.46h-1.71l-2.86-4.33v4.33h-1.71v-7.02h1.71l2.86,4.35v-4.35h1.71v7.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.09,23.28c-.41-.17-.73-.41-.97-.74-.24-.33-.37-.72-.39-1.18h1.82c.03,.26,.12,.46,.27,.59s.35,.21,.6,.21,.45-.06,.6-.17c.15-.12,.22-.28,.22-.49,0-.17-.06-.32-.18-.43s-.26-.21-.43-.28c-.17-.07-.41-.16-.73-.25-.45-.14-.82-.28-1.11-.42-.29-.14-.53-.35-.74-.62s-.31-.63-.31-1.07c0-.65,.24-1.17,.71-1.54,.47-.37,1.09-.55,1.85-.55s1.4,.19,1.87,.55c.47,.37,.73,.89,.76,1.55h-1.85c-.01-.23-.1-.41-.25-.54s-.35-.2-.59-.2c-.21,0-.37,.05-.5,.17s-.19,.27-.19,.47c0,.23,.11,.4,.32,.53s.55,.26,1,.41c.45,.15,.82,.3,1.1,.44,.28,.14,.53,.34,.74,.61,.21,.27,.31,.61,.31,1.03s-.1,.76-.31,1.09c-.2,.33-.5,.59-.89,.78s-.84,.29-1.37,.29-.97-.08-1.38-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.65,16.44v1.37h-2.86v1.48h2.14v1.33h-2.14v2.84h-1.71v-7.02h4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.26,17.81v1.42h2.29v1.32h-2.29v1.54h2.59v1.37h-4.3v-7.02h4.3v1.37h-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.33,22.22h-2.62l-.42,1.24h-1.79l2.54-7.02h1.98l2.54,7.02h-1.81l-.42-1.24Zm-.44-1.32l-.87-2.57-.86,2.57h1.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUt2Jensfea);
export default __webpack_public_path__ + "static/media/ut2jensfea.219752165408b957fd610ebcd9d80463.svg";
export { ForwardRef as ReactComponent };